<!-- 关于我，联系我 -->
<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
                <div class="intro">
                    <h1 class="text-center">这就是我！</h1>
                    <p class="text-center"><span class="by">by</span> <a href="#"> sim yuan</a><span class="date"> 2022
                        </span></p><img class="img-responsive" src="/desk.jpg">
                </div>
            </div>
        </div>
        <b-card-group>

            <b-card title="Card Title" img-src="https://picsum.photos/600/300/?image=2" img-alt="Image" img-top
                tag="article" style="max-width: 20rem;" class="mb-2">
                <b-card-text>
                    Some quick example text to build on the card title and make up the bulk of the card's content.
                </b-card-text>
                <b-button href="#" variant="primary">Go somewhere</b-button>
            </b-card>
            
            <b-card title="Card Title" img-src="https://picsum.photos/600/300/?image=2" img-alt="Image" img-top
                tag="article" style="max-width: 20rem;" class="mb-2">
                <b-card-text>
                    Some quick example text to build on the card title and make up the bulk of the card's content.
                </b-card-text>
                <b-button href="#" variant="primary">Go somewhere</b-button>
            </b-card>
    </b-card-group>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
    name: 'content',
    components: {},
    directives: {},
    filters: {},
    mixins: {},
    model: {},
    props: {},
    data() {
        return {

        }
    },
    computed: {},
    watch: {},
    beforeCreate() { },
    created() {

    },
    beforeMount() { },
    mounted() {

    },
    beforeUpdate() { },
    updated() { },
    activated() { },
    deactivated() { },
    beforeDestroy() { },
    destroyed() { },
    // 方法集合
    methods: {

    }
}
</script>
<style rel='stylesheet/less' scoped>

</style>